module.exports = __webpack_public_path__ + "static/store-ed429e29dbe037fae8dd4a95c83fdb81.jpg";